export const REPLACE_CREDIT_CARD_DETAILS_MODAL =
  'REPLACE_CREDIT_CARD_DETAILS_MODAL';
export const REPLACE_CREDIT_CARD_DETAILS_AUTO_RENEW_MODAL =
  'REPLACE_CREDIT_CARD_DETAILS_AUTO_RENEW_MODAL';
